import useSWR from 'swr'

const MOSS_RATE_API = 'https://api.getmoss.com/v1/rate-cbpr2'

export interface MossExchangeRateData {
  ccy1: string
  ccy2: string
  rate: number
  rateDate: string
  mastercardRate: number
  mastercardRateDate: string
  markupOverMastercard: number
  ecbRate: number
  markupOverEcb: number
  ecbRateDate: string
}

const fetcher = (url: string) =>
  fetch(url).then((res) => {
    if (!res.ok) {
      throw new Error('Failed to fetch exchange rate')
    }

    return res.json() as Promise<MossExchangeRateData>
  })

export function useMossExchangeRate(ccy1: string | null, ccy2: string | null) {
  const shouldFetch = ccy1 && ccy2 && ccy1 !== ccy2
  const key = shouldFetch ? `${MOSS_RATE_API}?ccy1=${ccy1}&ccy2=${ccy2}` : null

  return useSWR(key, fetcher)
}
